import { render, staticRenderFns } from "./CadastrarEditarAbasDialog.vue?vue&type=template&id=696f7571"
import script from "./CadastrarEditarAbasDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarAbasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports